import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import { extension, NodeExtension, ExtensionTag, isEmptyBlockNode, nodeInputRule, isNodeSelection, invariant, ErrorConstant } from '@remirror/core';
import { TextSelection } from '@remirror/pm/state';

var _dec, _class;
var HorizontalRuleExtension = (_dec = extension({
  defaultOptions: {
    insertionNode: 'paragraph'
  }
}), _dec(_class = class HorizontalRuleExtension extends NodeExtension {
  get name() {
    return 'horizontalRule';
  }

  createTags() {
    return [ExtensionTag.Block];
  }

  createNodeSpec(extra, override) {
    var _override$parseDOM;

    return _objectSpread(_objectSpread({}, override), {}, {
      attrs: extra.defaults(),
      parseDOM: [{
        tag: 'hr',
        getAttrs: extra.parse
      }, ...((_override$parseDOM = override.parseDOM) !== null && _override$parseDOM !== void 0 ? _override$parseDOM : [])],
      toDOM: node => ['hr', extra.dom(node)]
    });
  }

  createCommands() {
    return {
      /**
       * Inserts a horizontal line into the editor.
       */
      insertHorizontalRule: () => props => {
        var tr = props.tr,
            dispatch = props.dispatch;
        var $pos = tr.selection.$anchor;
        var initialParent = $pos.parent;

        if (initialParent.type.name === 'doc' || initialParent.isAtom || initialParent.isLeaf) {
          return false;
        }

        if (!dispatch) {
          return true;
        } // A boolean value that is true when the current node is empty and
        // should be duplicated before the replacement of the current node by
        // the `hr`.


        var shouldDuplicateEmptyNode = tr.selection.empty && isEmptyBlockNode(initialParent); // When the node should eb duplicated add it to the position after
        // before the replacement.

        if (shouldDuplicateEmptyNode) {
          tr.insert($pos.pos + 1, initialParent);
        } // Create the horizontal rule by replacing the selection


        tr.replaceSelectionWith(this.type.create()); // Update the selection if currently pointed at the node.

        this.updateFromNodeSelection(tr);
        dispatch(tr.scrollIntoView());
        return true;
      }
    };
  }

  createInputRules() {
    return [nodeInputRule({
      // Allow dash + hyphen to cater for ShortcutsExtension, which replaces first
      // two hyphens with a dash, i.e. "---" becomes "<dash>-"
      regexp: /^(?:---|—-|___\s|\*\*\*\s)$/,
      type: this.type,
      beforeDispatch: _ref => {
        var tr = _ref.tr;
        // Update to using a text selection.
        this.updateFromNodeSelection(tr);
      }
    })];
  }
  /**
   * Updates the transaction after a `horizontalRule` has been inserted to make
   * sure the currently selected node isn't a Horizontal Rule.
   *
   * This should only be called for empty selections.
   */


  updateFromNodeSelection(tr) {
    // Make sure  the `horizontalRule` that is selected. Otherwise do nothing.
    if (!isNodeSelection(tr.selection) || tr.selection.node.type.name !== this.name) {
      return;
    } // Get the position right after the current selection for inserting the
    // node.


    var pos = tr.selection.$from.pos + 1;
    var insertionNode = this.options.insertionNode; // If `insertionNode` was set to false, then don't insert anything.

    if (!insertionNode) {
      return;
    }

    var type = this.store.schema.nodes[insertionNode];
    !type ? process.env.NODE_ENV !== "production" ? invariant(false, {
      code: ErrorConstant.EXTENSION,
      message: "'".concat(insertionNode, "' node provided as the insertionNode to the '").concat(this.constructorName, "' does not exist.")
    }) : invariant(false) : void 0; // Insert the new node

    var node = type.create();
    tr.insert(pos, node); // Set the new selection to be inside the inserted node.

    tr.setSelection(TextSelection.create(tr.doc, pos + 1));
  }

}) || _class);

export { HorizontalRuleExtension };
